<template>
  <div class="login-view">
    <div v-if="!is_zhuce">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="formLabelCol" :wrapper-col="formWrapperCol">
        <a-form-model-item prop="username" label="用户名">
          <a-input size="large" v-model="form.username" />
        </a-form-model-item>
        <a-form-model-item prop="password" label="密码">
          <a-input-password size="large" v-model="form.password"/>
        </a-form-model-item>
      </a-form-model>

      <div class="login-actions">
        <a-button type="primary" size="large" :loading="isLoading" @click="login">登录</a-button>
      </div>

      <div @click="change_zhuce" class="switch-link">
        <a>没有账户？去注册</a>
      </div>
    </div>

    <div v-else class="register-form">
      <div class="register-row">
        <label>用户名:</label>
        <a-input size="large" v-model="reg.username" />
      </div>

      <div class="register-row">
        <label>邮箱:</label>
        <a-input size="large" v-model="reg.email" />
      </div>

      <div class="register-row">
        <label>密码:</label>
        <a-input-password size="large" v-model="reg.password" />
      </div>

      <div class="register-row">
        <label>验证码:</label>
        <div class="code-row">
          <a-input size="large" v-model="reg.code" />
          <a-button v-if="!is_send" @click="send_email" type="primary" size="large">发送</a-button>
          <a-button v-else type="primary" size="large" class="countdown-btn">{{second}}</a-button>
        </div>
      </div>

      <div class="register-actions">
        <a-button type="primary" size="large" :loading="isLoading" @click="register_user">注册</a-button>
      </div>

      <div @click="change_zhuce" class="switch-link">
        <a>已有账户？去登录</a>
      </div>

      <div class="warn-text">
        <a>{{warn}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { reg,sendemail,login } from '@/api/user';

export default {
  name: 'Login',
  data() {
    return {
      isLoading: false,
      isMobile: false,
      form: {
        username: '',
        password: '',
      },
      reg:{
        email:'',
        password:'',
        code:'',
        username:'',
      },
      rules: {
      },
      is_zhuce:false,
      second:60,
      is_send:false,
      warn:'',
      code_interval:null
    };
  },
  computed: {
    formLabelCol() {
      return this.isMobile ? { span: 24 } : { span: 5 };
    },
    formWrapperCol() {
      return this.isMobile ? { span: 24 } : { span: 14 };
    },
  },
  mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
    if (this.code_interval) {
      clearInterval(this.code_interval);
    }
  },
  methods: {
    updateViewport() {
      this.isMobile = window.innerWidth <= 768;
    },
    send_email(){
      if(this.reg.email==''){
        this.$message.warn('邮箱不能为空！');
        return;
      }
      sendemail(this.reg.email).then(res=>{
        console.log(res);
        if(res.code!=0||res.code==undefined){
          this.$message.error(res.message||'错误');
          return;
        }else{
          this.$message.success('发送成功');
          this.is_send=true;
          this.second=60;
          var that = this;
          this.code_interval = setInterval(function (){
            if(that.second==0){
              that.is_send=false;
              clearInterval(that.code_interval);
            }else{
              that.second--;
            }
          },1000);
        }
      }).finally((res)=>{

      });
    },
    register_user(){
      if(this.reg.email==''||this.reg.code==''||this.reg.password==''||this.reg.username==''){
        this.$message.warn('未填写完整');
        return;
      }
      this.isLoading=true;
      reg(this.reg).then(res => {
        console.log(res);
        if(res.code==0){
          this.$message.success('注册成功');
          this.change_zhuce();
        }else{
          this.$message.warn(res.message||'错误');
          this.reg.code='';
        }
      }).finally((res) => {
        this.isLoading=false;
      });
    },
    change_zhuce(){
      this.is_zhuce=!this.is_zhuce;
    },
    initialize() {

    },
    login() {
      if(this.form.username==''||this.form.password==''){
        this.$message.warn('未填写完整！');
        return;
      }
      this.isLoading=true;
      login(this.form).then((res)=>{
        console.log(res);
        if(res.code!=0||res.code==undefined){
          this.$message.error(res.message||'错误！');
        }else{
          this.$store.commit('setUser',{
            username:this.form.username,
            is_manager:true
          });
          const token = res.data;
          console.log(token);
          localStorage.setItem('token', token);
          console.log(localStorage.getItem('token'));
          this.$message.success('登录成功！');
          this.$router.push('/page/home');
        }
      }).finally(()=>{
        this.isLoading=false;
      })
    },
  }
}
</script>

<style scoped>
.login-view {
  width: 100%;
}

.login-actions {
  width: 58.333%;
  margin-left: 20.833%;
}

.login-actions .ant-btn,
.register-actions .ant-btn {
  width: 100%;
}

.switch-link {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
}

.switch-link a {
  font-size: 15px;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.register-row {
  display: flex;
  align-items: center;
  width: 70%;
  margin-left: 10%;
}

.register-row label {
  width: 100px;
  flex-shrink: 0;
}

.code-row {
  display: flex;
  width: 100%;
  gap: 20px;
}

.code-row .ant-btn {
  width: 100px;
  flex-shrink: 0;
}

.countdown-btn {
  background-color: #fff !important;
  color: #000 !important;
}

.register-actions {
  width: 200px;
  margin: 20px auto 0;
}

.warn-text {
  display: flex;
  justify-content: center;
  width: 100%;
  color: red;
}

.warn-text a {
  font-size: 15px;
  color: red;
}

@media (max-width: 768px) {
  .login-actions {
    width: 100%;
    margin-left: 0;
  }

  .register-form {
    gap: 14px;
  }

  .register-row {
    display: block;
    width: 100%;
    margin-left: 0;
  }

  .register-row label {
    display: block;
    width: 100%;
    margin-bottom: 6px;
  }

  .code-row {
    gap: 8px;
  }

  .code-row .ant-btn {
    width: 86px;
  }

  .register-actions {
    width: 100%;
    margin-top: 12px;
  }
}
</style>
